/* import __COLOCATED_TEMPLATE__ from './share-schedule-button.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type ReportAccessService from 'embercom/services/report-access-service';
import type Report from 'embercom/models/reporting/custom/report';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type CustomReportsService from 'embercom/services/custom-reports-service';
interface Args {
  disabled: boolean;
  report: Report;
  openShareSideDrawer: () => void;
  openExternalSharingSideDrawer?: () => void;
  openScheduleDeliveryDrawer?: () => void;
}

export default class ReportingCustomReportShareScheduleButton extends Component<Args> {
  @service declare reportAccessService: ReportAccessService;
  @service declare appService: AppService;
  @service declare customReportsService: CustomReportsService;
  @service declare permissionsService: any;

  get hasWorkspaceAccess(): boolean {
    let accessControlList = this.reportAccessService.localAccessControls;
    return isPresent(accessControlList.find((control) => control.isWorkspaceAccessControl));
  }

  get shareIcon() {
    return this.hasWorkspaceAccess ? 'share' : 'locked';
  }

  @action
  openManageAccess(hideDropdownOverlay?: () => void) {
    this.args.openShareSideDrawer();
    hideDropdownOverlay?.();
  }

  @action
  openShareExternally(hideDropdownOverlay?: () => void) {
    if (this.permissionsService.currentAdminCan('can_export_csv')) {
      this.args.openExternalSharingSideDrawer?.();
    } else {
      this.permissionsService.loadAllAdminsAndShowPermissionRequestModal('can_export_csv');
    }
    hideDropdownOverlay?.();
  }

  @action
  openScheduleDelivery(hideDropdownOverlay?: () => void) {
    this.args.openScheduleDeliveryDrawer?.();
    hideDropdownOverlay?.();
  }

  @action
  openManageSchedules(hideDropdownOverlay?: () => void) {
    // TODO: implement manage schedules functionality
    hideDropdownOverlay?.();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::ShareScheduleButton': typeof ReportingCustomReportShareScheduleButton;
    'reporting/custom/report/share-schedule-button': typeof ReportingCustomReportShareScheduleButton;
  }
}
